import { createBreakpoints } from '@chakra-ui/theme-tools'

export const BREAKPOINT_VALS = {
  xs: '22.5em',
  sm: '30em',
  md: '48em',
  lg: '64em',
  xl: '90em',
}

export const breakpoints = createBreakpoints(BREAKPOINT_VALS)
